import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  WebExpertsLogo,
  RatingDallasLiveApp,
  RatingDallasIndustry,
  WebClutchRatingLogo,
} from "../../../app-constants";
import { StaticImage } from "gatsby-plugin-image";

const Ratingusa = () => {
  return (
    <div className="rating_usa rating_web_dev rating_dubai p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={6} md={3} lg={3} xl={3} xxl={3}>
            <div className="rating_box">
              <div className="rating-svg">
                <StaticImage
                  src="../../images/locationgcc/dubai_new/app_dev_dubai.webp"
                  alt="TekRevol"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={96}
                  height={95}
                />
              </div>
              <div className="rating-content">
                <div className="rating-num">150+</div>
                <p>App Experts</p>
              </div>
            </div>
          </Col>
          <Col xs={6} md={3} lg={3} xl={3} xxl={3}>
            <div className="rating_box">
              <div className="rating-svg">
                <StaticImage
                  src="../../images/locationgcc/dubai_new/live_apps_dubai.webp"
                  alt="TekRevol"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={96}
                  height={96}
                />
              </div>
              <div className="rating-content">
                <div className="rating-num">200+</div>
                <p>Live Apps</p>
              </div>
            </div>
          </Col>
          <Col xs={6} md={3} lg={3} xl={3} xxl={3}>
            <div className="rating_box">
              <div className="rating-svg">
                <StaticImage
                  src="../../images/locationgcc/dubai_new/industry_dubai.webp"
                  alt="TekRevol"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={96}
                  height={96}
                />
              </div>
              <div className="rating-content">
                <div className="rating-num">15+</div>
                <p>Industries Covered</p>
              </div>
            </div>
          </Col>
          <Col xs={6} md={3} lg={3} xl={3} xxl={3}>
            <div className="rating_box">
              <div className="rating-svg">{WebClutchRatingLogo}</div>
              <div className="rating-content">
                <div className="rating-num">75+</div>
                <p>Clutch Reviews</p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Ratingusa;
